module.exports = __webpack_public_path__ + "img/[失望].c35cc516.svg";